import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AktuelBrugerObserver, Rolle } from "@e-forsyning/common/bruger";
import { EBoksTilmeldingService } from "@e-forsyning/common/e-boks";

import { MineOplysningerRepository } from "./mine-oplysninger.repository";
import { MineOplysningerViewModel } from "./model/mine-oplysninger.view-model";

@Injectable({ providedIn: "root" })
export class MineOplysningerSandbox {
    constructor(
        private readonly eBoksTilmeldingService: EBoksTilmeldingService,
        private readonly aktuelBrugerObserver: AktuelBrugerObserver,
        private readonly mineOplysningerRepository: MineOplysningerRepository
    ) {}

    public hentViewModel(): Observable<MineOplysningerViewModel> {
        const erMobilVisning = this.erMobilVisning();
        const visEBoksSektion$ = this.eBoksTilmeldingService.hentIndstillinger().pipe(map((result: any) => result.visEBoksSektion));
        const erForbruger$ = this.aktuelBrugerObserver.valueChanges.pipe(map((bruger) => bruger && bruger.rolle === Rolle.Forbruger));
        const indstillinger$ = this.mineOplysningerRepository.hentIndstillinger();
        return combineLatest([visEBoksSektion$, erForbruger$, indstillinger$]).pipe(
            map(([visEBoksSektion, erForbruger, indstillinger]) => ({
                erMobilVisning,
                visEBoksSektion,
                erForbruger,
                sideTitel: indstillinger.sideTitel
            }))
        );
    }

    private erMobilVisning(): boolean {
        return window.screen.width === 360;
    }
}
